/**
 * @generated SignedSource<<efd28b56d29f73e06e1b1df98f8abaeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicCreatePieceInput = {
  original_file_names: ReadonlyArray<string>;
};
export type CreateMusicPieceMutation$variables = {
  input: MusicCreatePieceInput;
};
export type CreateMusicPieceMutation$data = {
  readonly music_create_piece: {
    readonly piece: {
      readonly id: string;
      readonly pages: ReadonlyArray<{
        readonly id: string;
        readonly input_upload_url: string;
      }>;
    };
  };
};
export type CreateMusicPieceMutation = {
  variables: CreateMusicPieceMutation$variables;
  response: CreateMusicPieceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicPieceOutput",
    "kind": "LinkedField",
    "name": "music_create_piece",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicPiece",
        "kind": "LinkedField",
        "name": "piece",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "input_upload_url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMusicPieceMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMusicPieceMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7ddcd07bf567f4c8d8ad16905c837c0d",
    "id": null,
    "metadata": {},
    "name": "CreateMusicPieceMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMusicPieceMutation(\n  $input: MusicCreatePieceInput!\n) {\n  music_create_piece(input: $input) {\n    piece {\n      id\n      pages {\n        id\n        input_upload_url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "927c00dc6244e0591ce5e55f0d31bc16";

export default node;
